export { default } from './CampaignDescription'
